<template>
  <div id="templatePane">
    <div class="hero-section shade-40">
      <div class="hero-section-text row column">
        <h1 v-if="!loading">{{ $t('lang.user-notice.hero-title') }}</h1>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <section id="mainContent" class="row content" v-if="!loading" key="loading-finished">
        <nav class="hide-for-small-only medium-4 column" data-sticky-container>
          <div :lang="$i18n.locale | parseLanguage" :dir="$t('lang.dir')" data-anchor="mainContent" data-sticky
            data-sticky-on="medium">
            <h2>{{ $t('lang.user-notice.contents') }}</h2>
            <ul class="vertical menu" data-magellan>
              <li v-for="index in parseInt($t('lang.user-notice.number-of-user-notice-headings'))" :key="index">
                <a :href="'#heading-' + index">{{ $t('lang.user-notice.heading-' + index) }}</a>
              </li>
            </ul>
            <section v-if="$t('lang.user-notice.number-of-privacy-notice-headings') > 0">
              <h2>{{ $t('lang.user-notice.privacy-notice-contents') }}</h2>
              <ul class="vertical menu" data-magellan>
                <li v-for="index in parseInt($t('lang.user-notice.number-of-privacy-notice-headings'))" :key="index">
                  <a :href="'#privacy-notice-heading-' + index">{{ $t('lang.user-notice.privacy-notice-heading-' + index)
                  }}</a>
                </li>
              </ul>
            </section>
          </div>
        </nav>
        <form ref="useragreement" class="medium-8 column" v-on:submit.prevent="submit" id="user-agreement" novalidate
          data-abide>
          <section v-if="this.static">
            <label for="regionSelect">Select a region</label>
            <select id="regionSelect" v-model="region" @change="updateRegion($event)" aria-label="Select a region"
              title="Select a region">
              <option v-for="(region) in this.components" :key="region.name" :value="region.name | parseRegion">{{
                region.friendlyName }}</option>
            </select>
          </section>
          <div class="locale-changer" v-show="this.langs.length > 1">
            <label for="languageSelect">View this notice in</label>
            <select id="languageSelect" v-model="$i18n.locale" aria-label="Select your preferred language"
              title="Select your preferred language">
              <option v-for="(lang, i) in this.langs" :key="region + '_' + `Lang${i}`" :value="region + '_' + lang[0]">{{
                lang[1]
              }}</option>
            </select>
            <hr />
          </div>

          <section v-if="!this.static">
            <div class="checkbox">
              <input v-model="accepted" class="checkbox-input" type="checkbox" name="accept-agreement" id="yes"
                value="true" />
              <label class="checkbox-label" for="yes">{{ $t('lang.user-notice.i-have-read-and-accept') }}</label>
            </div>

            <p class="button-holder">
              <button class="button" type="submit" :disabled="accepted == 0">{{ $t('lang.user-notice.continue-button')
              }}</button>
            </p>
          </section>

          <div :lang="$i18n.locale | parseLanguage" :dir="$t('lang.dir')">
            <component v-bind:is="userAgreementComponent" />
          </div>

        </form>
      </section>
      <section class="content" v-if="loading" key="still-loading">
        <img class="loading" src="/static/images/ajax-loader.gif">
      </section>
    </transition>
  </div>
</template>

<script>
import api from '../../api'
import authentication from '../../authentication'
import countryRegion from '../../locales/country_region.json'
import regionLanguage from '../../locales/region_language.json'
import UserAgreementAMEA from './useragreements/UserAgreementAMEA.vue'
import UserAgreementUK from './useragreements/UserAgreementUK.vue'
import UserAgreementINDIA from './useragreements/UserAgreementINDIA.vue'
import UserAgreementAMERICAS from './useragreements/UserAgreementAMERICAS.vue'
import UserAgreementEUROPE from './useragreements/UserAgreementEUROPE.vue'
import UserAgreementSPAIN from './useragreements/UserAgreementSPAIN.vue'
import UserAgreementHUNGARY from './useragreements/UserAgreementHUNGARY.vue'
import UserAgreementITALY from './useragreements/UserAgreementITALY.vue'
import UserAgreementPORTUGAL from './useragreements/UserAgreementPORTUGAL.vue'
import UserAgreementGERMANY from './useragreements/UserAgreementGERMANY.vue'

const componentList = { UserAgreementAMEA, UserAgreementAMERICAS, UserAgreementEUROPE, UserAgreementHUNGARY, UserAgreementINDIA, UserAgreementITALY, UserAgreementPORTUGAL, UserAgreementSPAIN, UserAgreementGERMANY, UserAgreementUK }

import router from '../../router';
export default {
  name: 'UserAgreement',
  title: 'Workplace user notice',
  components: componentList,
  data: function () {
    return {
      accepted: false,
      loading: true,
      langs: [['EN', 'English']],
      countryCode: 'GB',
      region: 'UK',
      userLanguage: 'EN',
      userAgreementComponent: 'UserAgreementUK',
      static: false,
      components: componentList
    }
  },
  methods: {
    submit: function () {
      if (this.accepted) {
        this.accept();
      }
    },
    accept: function () {
      if (!authentication.getCachedToken()) {
        authentication.acquireTokenRedirect();
      } else {
        authentication.getCachedToken().then(response => {
          var token = response.rawIdToken;
          api.acceptAgreement(token)
            .then(response => {
              localStorage.acceptedLicense = "true";
              router.push('phone-number');
            })
            .catch(err => {
              console.error(err);
              router.push(this.getErrorRedirect(err))
            })
        })
      }
    },
    checkUserEligibility: function () {
      if (authentication.getCachedToken()) {
        authentication.getCachedToken().then(response => {
          var token = response.rawIdToken;
          api.getUserEligibility(token)
            .then(response => {
              // Country code is Azure (JP for Japan), whereas Language is from Browser (JA for Japanese)
              this.countryCode = response.data.countryCode.toUpperCase();
              this.processUserRegion();
            })
            .catch(error => {
              router.push(this.getErrorRedirect(error))
            })
        })
      } else {
        // The following is useful for Debug
        //this.countryCode = "PL";
        //this.processUserRegion();
      }
    },
    processUserRegion: function () {
      this.region = countryRegion[this.countryCode];
      if (typeof (this.region) === "undefined") {
        console.log("Region undefined, setting to UK");
        this.region = "UK";
      }
      this.processUserLanguage();
    },
    processUserLanguage: function () {
      console.log(`Region: ${this.region}`);

      // Set the regional User Notice
      this.userAgreementComponent = `UserAgreement${this.region}`;

      // Set the languages available for this region
      this.langs = regionLanguage[this.region];
      if (typeof (this.langs) === "undefined") {
        this.langs = [];
      }
      console.log("Langs: " + this.langs);
      this.userLanguage = navigator.language.split('-')[0].toUpperCase();
      var userLanguageFound = false;

      for (let index = 0; index < this.langs.length; ++index) {
        // Check if this user's language is in the list of languages for the region
        if (this.langs[index][0].toUpperCase() === this.userLanguage) {
          console.log("User's language " + this.userLanguage + " found");
          userLanguageFound = true;
          this.$i18n.locale = this.region + "_" + this.userLanguage;
          break;
        }
      }

      if (!userLanguageFound) {
        // If we didn't find the user's language in the region's list of languages, default it to the first language in the list (normally English)
        console.log("User's language " + this.userLanguage + " not found, defaulting to primary language: " + this.langs[0][0].toUpperCase());
        this.userLanguage = this.langs[0][0].toUpperCase();
        this.$i18n.locale = this.region + "_" + this.userLanguage;
      }

      console.log("Locale set to: " + this.$i18n.locale);
      this.loading = false;
      this.$nextTick(function () {
        this.reinitFoundation()
      })
    },
    reinitFoundation: function () {
      const stickyEl = $('[data-sticky]')
      const magellanEl = $('[data-magellan]')
      if ((stickyEl.length > 0) && (magellanEl.length > 0)) {
        this.sticky = new Foundation.Sticky(stickyEl, { 'data-sticky-on': 'medium' })
        this.magellan = new Foundation.Magellan(magellanEl)
      }
    },
    updateRegion: function (event) {
      console.log("updateRegion: " + event.target.value);
      this.region = event.target.value;
      this.processUserLanguage();
    }
  },
  beforeMount: function () {
    this.reinitFoundation()
  },
  mounted: function () {
    this.reinitFoundation()
  },
  updated: function () {
    this.$nextTick(function () {
      this.reinitFoundation()
    })
  },
  created() {
    // If we're arriving from the static URL
    if (this.$route.name === "StaticUserAgreementNotice") {
      this.region = "UK";
      this.processUserLanguage();
      this.static = true;
      this.loading = false;
    } else {
      this.checkUserEligibility();
    }
  },
  destroyed() {
    if (typeof this.sticky !== 'undefined') {
      this.sticky.destroy()
    }
    if (typeof this.magellan !== 'undefined') {
      this.magellan.destroy()
    }
  },
  filters: {
    parseLanguage: function (value) {
      return value.split('_')[1].toLowerCase();
    },
    parseRegion: function (value) {
      return value.split('UserAgreement')[1];
    }
  }
}
</script>

<style>
.loading {
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-top: 30px;
  margin-bottom: 50px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.content {
  min-height: 100px;
}

.icon {
  font-size: 2em;
  padding-top: 5px;
}

.col-center {
  text-align: center;
}

.multi-list {
  margin-bottom: 0;
}

div[dir="rtl"] ul {
  margin-left: 0;
  margin-right: 1.25rem;
}

ul ul {
  list-style-type: circle;
}

.no-bottom-pad {
  margin-bottom: 0;
}

.bold {
  font-weight: bold;
}

.left-pad {
  padding-left: 1rem;
}

.country {
  margin-top: 1rem;
}

h3 {
  font-weight: bold;
}
</style>

